<template>
    <div>
        <template v-if="loaded">
            <Tabs
                :data="{ additionals, form, model }"
                ref="Tabs"
            />
        </template>
    </div>
</template>

<script>
// Components.
import Tabs from './Tabs'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, unmask, stringCase, object } from '@/mixins'

export default {
    components: { Tabs },
    created() {

        this.repositories = {
            fornecedor: this.getConectaSusRepository('cadastro.fornecedor')
        }

        this.load()
    },
    data: () => ({
        additionals: null,
        form: null,
        loaded: false,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const request = this.id
                ? this.repositories.fornecedor.edit(this.id)
                : this.repositories.fornecedor.create()

            request
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Tabs.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const request = this.id
                        ? this.repositories.fornecedor.update(this.id, this.prepareData())
                        : this.repositories.fornecedor.store(this.prepareData())

                    request
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.cnpj = data.cnpj != null ? this.unMaskCnpj(data.cnpj) : null
            data.telefones.map(t => t.numero = this.unMaskPhone(t.numero))
            data.contatos.map(c => c.telefone = this.unMaskPhone(c.telefone))

            data.endereco = data.endereco.logradouro ? {
                logradouroId: data.endereco.logradouro.id,
                numero: data.endereco.numero,
                complemento: data.endereco.complemento,
                referencia: data.endereco.referencia,
            } : null

            return this.camelObjectKeysToSnakeRecursive(data)
        },
    },
    mixins: [ repository, error, unmask, stringCase, object ],
    props: {
        id: { type: Number }
    },
}
</script>